module.exports = __webpack_public_path__ + "img/logo-1.fb0e8185.png";